import React from 'react';
import Product from './product';

const ProductGroups = (props) => {
  return (
    <div className="productGroupsContainer">
      {props.customizations
      .map((productGroup) => {
        return (
          <div key={productGroup.id}>
            {productGroup.products
            .map(product => (<Product
              key={product.id}
              updateSizeItem={props.updateSizeItem}
              data={product}
              groupID={productGroup.id}
              addSponsorLogo={props.addSponsorLogo}
            />))}
          </div>
        );
        })}
    </div>
  );
};

export default ProductGroups;
